import CarLayout1Container from "../../../components/car/detail/CarLayout1";

const CarLayout1 = () => {
  return <CarLayout1Container />;
};

export default CarLayout1;
